<template>
  <div class="home-international-container">
    <div class="home-international-info">
      <h1>{{ $t('home.inter.title') }}</h1>
      <p>{{ $t('home.inter.info') }}</p>
      <div class="privacy-points">
        <div>{{ $t('home.inter.point1') }}</div>
        <div>{{ $t('home.inter.point2') }}</div>
        <div>{{ $t('home.inter.point3') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeInternational',
  components: {

  }
}
</script>

<style lang="less" scoped>
  .home-international-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52.3125rem;
    width: 100%;
    background-color: #222222;
    .home-international-info{
      display: flex;
      flex-direction: column;
      height: 100%;
      h1{
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 600;
        font-size: 3.625rem;
        line-height: 150%;
        letter-spacing: -0.02em;
        background: linear-gradient(90deg, #EAE450 4.94%, #16A9FC 103.87%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        margin-top: 5.125rem;
      }
      p{
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 1.9375rem;
        line-height: 160%;
        letter-spacing: -0.02em;
        color: #FFFFFF;
        margin-top: 0.9375rem;
      }
      .privacy-points {
        display: flex;
        width: 76.25rem;
        margin-top: 5rem;
        justify-content: space-between;
        div {
          width: 31%;
          padding: 3rem 2rem;
          border: 1px solid rgba(255, 255, 255, 0.18);
          border-radius: 2rem;
          background: rgba(255, 255, 255, 0.06);
          color: #FFFFFF;
          font-size: 1.5rem;
          line-height: 1.6;
        }
      }
    }
    .item{
      display: flex;
    }
  }
  @media only screen and (max-width: 500px) {
    .home-international-container {
      height: 292px;
      .home-international-info {
        h1{
          font-size: 23.2px;
          margin-top: 31px;
        }
        p{
          font-size: 12.4px;
          margin-top: 5.8px;
        }
        .privacy-points {
          width: 340px;
          margin-top: 24px;
          div {
            padding: 14px 8px;
            border-radius: 12px;
            font-size: 9px;
          }
        }
    }
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/subcomponents/HomeInternational.vue